import React from 'react';
import LoginTemplate from 'components/shared/layout/loginTemplate/presentational/LoginTemplate';

const Auth = ({ children }) => {
    return <LoginTemplate>{children}</LoginTemplate>;
};

export default Auth;
